import { render, staticRenderFns } from "./TaskTypePhotoOrder.vue?vue&type=template&id=55bf6590&scoped=true"
import script from "./TaskTypePhotoOrder.vue?vue&type=script&lang=js"
export * from "./TaskTypePhotoOrder.vue?vue&type=script&lang=js"
import style0 from "./TaskTypePhotoOrder.vue?vue&type=style&index=0&id=55bf6590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf6590",
  null
  
)

export default component.exports